// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 9261 ? "routes-Search" : chunkId) + "." + {"4369":"473207eb","5948":"e0490faa","9170":"e1d03a83","9261":"e2e7552e"}[chunkId] + ".chunk.css";
};